module.exports = __webpack_public_path__ + "img/bch.95130e37.svg";